var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import * as React from 'react';
/**
 * The GridColumnMenuItemGroup that will be used inside the Grid ColumnMenu.
 */

var GridColumnMenuItemGroup = function (_super) {
  __extends(GridColumnMenuItemGroup, _super);

  function GridColumnMenuItemGroup() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  /**
   * @hidden
   */


  GridColumnMenuItemGroup.prototype.render = function () {
    var children = this.props.children;
    return React.createElement("div", {
      className: "k-columnmenu-item-wrapper"
    }, children);
  };

  return GridColumnMenuItemGroup;
}(React.Component);

export { GridColumnMenuItemGroup };